export default "__VITE_ASSET__BNdgP18R__"